import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  type: null, // 'image' or 'richtext'
  content: null, // URL for image, HTML string for richtext
};

const contentPreviewSlice = createSlice({
  name: "contentPreview",
  initialState,
  reducers: {
    openImagePreview: (state, action) => {
      state.isOpen = true;
      state.type = "image";
      state.content = action.payload;
    },
    openRichTextPreview: (state, action) => {
      state.isOpen = true;
      state.type = "richtext";
      state.content = action.payload;
    },
    closePreview: (state) => {
      state.isOpen = false;
      state.type = null;
      state.content = null;
    },
  },
});

export const { openImagePreview, openRichTextPreview, closePreview } =
  contentPreviewSlice.actions;

export const selectContentPreview = (state) => state.contentPreview;

export default contentPreviewSlice.reducer;
